import React from "react";
import "./deliveryMethod.css";
import ValidationComponent from "../../../Shared/validationComponent";
import { isMobile } from "../../../helpers/utils";
import './mobileStyle.css';

const PushNotificationComponent = (props) => {
  const disabled =
    props.deliveryEditItem.currentEditItemType !== "Push" &&
    props.deliveryEditItem.currentEditItemType !== "";

  const addDisabled =
    props.deliveryAddItem.currentAddItemType !== "Push" &&
    props.deliveryAddItem.currentAddItemType !== "";

  return (
    <div
      id="dvpushnotifysection"
      className={

        (disabled ? "disabled-dm" : "") +
        (addDisabled ? "disabled-dm" : "")
      }
    >
      <h3 id="pushNotify" className={isMobile() ? `mobile-font-family mobile-category` : `pushNotification-header`}>{props.name}</h3>
      <div className="hr-addEdit-deliveryMethod" />
      {props.items.length !== 0 && (
        <div className={isMobile() ? "displayFlex columnflex justify-content" : "displayFlex justify-content"}>
          <div>
            {props.items.map((item, key) => {
              return (
                <div key={key}>
                  <div className="displayFlex">

                    <label className={isMobile() ? `mobile-font-family colleftalign mobile-align-content-items-for-delivery-method` : `colleftalign align-content-items-for-delivery-method`}>
                      {item.nickname}
                    </label>

                    {!item.isVerified && (
                      <ValidationComponent
                        cssCls={"justify-content-center align-items-center"}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={isMobile() ? `mobile-align-push-notifications-message` : `align-push-notifications-message`}
          >
            {isMobile() ? <div className="align-push-notification-item" role="text">
            To remove a device, 
            tap <b><i>Profile & Settings</i></b>, then <b><i>Device Management</i></b>.
            Tap <b><i>remove</i></b> next to the device name.
                </div>:<div className="align-push-notification-item" role="text">             
             <b>How to remove a device </b><br/>
             Select the <b><i>Profile & Security</i></b> dropdown, then&nbsp;
             <b><i>Security Center</i></b>. Select <b><i>Manage Devices</i></b>, then 
             select <b><i>remove</i></b> next to the device name.
                </div>
            }
           </div>
        </div>
      )}
      {props.items.length === 0 && (
        <div className={isMobile() ? `mobile-font-family add-new-item-mobile margin-unset padding-top padding-bottom italic` : `spacing padding-top padding-bottom italic`}>
          No devices found
        </div>
      )}
      <div className="hr-addEdit-deliveryMethod" />
    </div>
  );
}

export default PushNotificationComponent;
